export { default, getStaticProps } from "app/parrainage/page";
